var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGallery(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "20px",
    viewBox: "0 0 22 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icGallery") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messenger-Inbox---photo-upload",
    transform: "translate(-20.000000, -467.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gallery",
    transform: "translate(20.000000, 467.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 19,
    rx: 5
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-6",
    strokeWidth: 0.8,
    cx: 7.46086957,
    cy: 5.5,
    rx: 1.46086957,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(4.000000, 5.000000)",
    strokeWidth: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.001,2.99998 C9.001,2.99998 8.001,5.99998 6.501,5.99998 C5.001,5.99998 5.002,4.99998 3.001,4.99998 C1.001,4.99998 0,8.99998 0,8.99998 L14.001,8.99998 C14.001,8.99998 13.001,2.99998 11.001,2.99998",
    id: "Fill-3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.000000, 4.000000)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGallery);
export default __webpack_public_path__ + "static/media/icGallery.9a9b7f2b87d6b2d558c67a9a55d0c04b.svg";
export { ForwardRef as ReactComponent };